const s = {
  name: "PaintRoller",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M2,0v5H0v2h2v5h2v9c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3v-4c0-0.5,0.5-1,1-1s1,0.5,1,1c0,1.7,1.3,3,3,3s3-1.3,3-3
			v-5h18V7h2v7.2l-12.3,2.6C21.8,17.6,19,21,19,25h-3v11c0,2.2,1.8,4,4,4s4-1.8,4-4V25h-3c0-3,2.1-5.6,5.1-6.3L40,15.8V5h-4V0H2z
			 M6,12h10v5c0,0.5-0.5,1-1,1s-1-0.5-1-1c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3v4c0,0.5-0.5,1-1,1c-0.5,0-1-0.5-1-1V12z M34,10H4V2h30
			V10z M18,36v-9h4v9c0,1.1-0.9,2-2,2S18,37.1,18,36z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PaintRoller
};
